<br />
<p class="text-justify">

    REVOGAÇÃO DE PRESTAÇÃO DE SERVIÇOS - CONECTIVIDADE E CERTIFICAÇÃO ELETRÔNICA
    CAIXA X EMPRESA
        
</p>
<br />
<p class="text-justify">

        Pelo presente instrumento, CAIXA ECONÔMICA FEDERAL, com sede no Setor Bancário Sul, Quadra 4, Lotes 3 e 4 - 
        CEP 70092 - 900, Brasília - DF, CGC 00360305/0001-04, neste ato representada por doravante denominada CAIXA, e, de outro 
        lado, a empresa {{infoContratos.razaoSocial}}, com inscrição CPF n.º {{ inscricaoFormatada }}, doravante denominada CLIENTE, ajustam 
        e celebram este convênio para os fins e sob as condições adiante indicadas. 

        O presente termo tem por objetivo revogar o atual Termo do Contrato de Prestação de Serviço do CLIENTE, que 
        possui os seguintes serviços:


    </p>
    <br />
    <p class="text-justify">
        PERFIL:  {{infoContratos.desPerfil}}
    </p>
    <br />
    
    <strong>Serviços Disponíveis:</strong>
    
    <ul>
        <li *ngFor="let servico of infoContratos.servicos">{{servico}}</li>
    </ul>
    
    <br />
    <br />
    <br />
    <br />
    
    
    <ul>
            <p class="text-justify">
                    ____________________________________________ 
            </p>        
            <p class="text-justify">
                    Local e data 
            </p>        
            
    </ul>
    
    <br />
    <br />
    
    <ul>
            <p class="text-justify">
                    ______________________________________________ 
            </p>    
            <p class="text-justify">
                    CAIXA ECONÔMICA FEDERAL 
            </p>        
    
    </ul>
    
    <br />
    <br />
    
    <ul>
            <p class="text-justify">
                    ______________________________________________ 
            </p>        
            <p class="text-justify">
                    CLIENTE - Representante legal da Empresa 
            </p>        
    </ul>
    
    <br />
    <br />
    
    <ul>
            <p class="text-justify">
                    Testemunhas: 
            </p>        
    </ul>
                  
    <br />
    <br />
    
    <ul>
            <p class="text-justify">
                    _______________________________ _________________________________ 
            </p>        
            <p class="text-justify">
                    CPF                                                      CPF
            </p>        
    
    </ul>
                  